var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1654 30.9167L19.9987 31.0833L19.8154 30.9167C11.8987 23.7333 6.66536 18.9833 6.66536 14.1667C6.66536 10.8333 9.16536 8.33333 12.4987 8.33333C15.0654 8.33333 17.5654 10 18.4487 12.2667H21.5487C22.432 10 24.932 8.33333 27.4987 8.33333C30.832 8.33333 33.332 10.8333 33.332 14.1667C33.332 18.9833 28.0987 23.7333 20.1654 30.9167ZM27.4987 5C24.5987 5 21.8154 6.35 19.9987 8.46667C18.182 6.35 15.3987 5 12.4987 5C7.36536 5 3.33203 9.01667 3.33203 14.1667C3.33203 20.45 8.9987 25.6 17.582 33.3833L19.9987 35.5833L22.4154 33.3833C30.9987 25.6 36.6654 20.45 36.6654 14.1667C36.6654 9.01667 32.632 5 27.4987 5Z",
    fill: "#E58411"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.dfeb82ab394d443ae42d50053e137984.svg";
export { ForwardRef as ReactComponent };